<script>
  export let id = -1;

  import Menu from "../components/Menu.svelte";
  import Breadcrumbs from "../components/Breadcrumbs.svelte";
  import Footer from "../components/Footer.svelte";
  import AcceptCancelDialog from "../components/AcceptCancelDialog.svelte";
  import AcceptCancelDialogRevision from "../components/AcceptCancelDialogRevision.svelte";
  import ArticleEditorItem from "../components/ArticleEditorItem.svelte";
  import ArticleVersion from "../components/ArticleVersion.svelte";
  import ArticleReviewerItem from "../components/ArticleReviewerItem.svelte";
  import EmailDialog from "../components/EmailDialog.svelte";
  import RechazarRevisionDialog from "../components/RechazarRevisionDialog.svelte";
  import IconButton from "../components/IconButton.svelte";
  import LoadingDialog from "../components/LoadingDialog.svelte";

  import { dictionary, language } from "../utils/stores.js";
  import { getToken, redirectIfNotToken } from "../utils/token.js";
  import { post } from "../utils/api.js";
  import { loadFile } from "../utils/revista.js";
  import { readTextFile } from "../utils/readFile";
  import { sendEmail } from "../utils/email";

  import { onMount } from "svelte";

  redirectIfNotToken("/login");

  let dict;
  let lang;

  let miRol = "EditorJefe";

  const unsubscribe = dictionary.subscribe((value) => {
    dict = value;
  });

  language.subscribe((value) => {
    lang = value;
  });

  const pageName = "articulos";
  let filtro = "todos";
  let articulo = null;
  let figurasDoc1 = [];
  let figurasDoc2 = [];
  let editores = [];
  let editoresSel = [];
  let editorSel = "-1";
  let revisores = [];
  let revisoresSel = [];
  let revisorSel = "-1";
  let documento1Doc = null;
  let documento1Pdf = null;
  let documento2Doc = null;
  let documento2Pdf = null;
  let estadoArticulo = "";
  let estadoColor = "";
  let version = 1;

  let sendEmailEmail = "";
  let sendEmailSubject = "";
  let sendEmailBody = "";
  let sendEmailAdjuntos = [];
  let sendEmailOnSent = null;
  let sendEmailBeforeSend = null;

  let posRevisor = 1;
  let revisionMotivoRechazo = "noTiempo";
  let revisionPropuestaRevisores = [];
  let letterAuthors = "";
  let letterEditors = "";
  let letterAuthorsDoc1 = "";
  let letterEditorsDoc1 = "";
  let letterAuthorsDoc2 = "";
  let letterEditorsDoc2 = "";
  let lettersAuthorsDoc1 = [];
  let lettersAuthorsDoc2 = [];
  let lettersEditorsDoc1 = [];
  let lettersEditorsDoc2 = [];
  let errorMsgRevisor = "";
  let errorMsgEditor = "";
  let estadoRevision = "";
  let estadoRevisionDoc1 = "";
  let estadoRevisionDoc2 = "";
  let emailsAuthors = [];
  let aceptacionEditor = "";

  let removeReviewerAction = null;

  let loading = false;
  let loadingText = "";

  let aceptarSegundaRevision = true;

  let letterProposeReviewer = "";
  let letterProposeEditor = "";
  let letterReviewerAccepts = "";
  let letterReviewerAcceptsEditor = "";
  let letterReviewerRejects = "";
  let letterReviewerRejectsEditor = "";
  let letterReviewerThanks = "";
  let letterReviewerThanksEditor = "";
  let letterReviewerNoSecondRound = "";
  let letterAcceptedAuthors = "";
  let letterMinorAuthors = "";
  let letterMajorAuthors = "";
  let letterRejectedAuthors = "";
  let letterAcceptedReviewers = "";
  let letterAcceptedChiefEditors = "";
  let letterMinorReviewers = "";
  let letterMajorReviewers = "";
  let letterRejectedReviewers = "";
  let letterRejectedChiefEditors = "";

  onMount(async () => {
    await obtenerArticulo();
    if (articulo.miRol === "Editor" || articulo.miRol === "EditorJefe") {
      obtenerEditores();
      obtenerRevisores();
    }
    obtenerArticuloDocumentos();

    letterProposeReviewer = await readTextFile("/letters/propose-reviewer.txt");
    letterProposeEditor = await readTextFile("/letters/propose-editor.txt");
    letterReviewerAccepts = await readTextFile("/letters/reviewer-accepts.txt");
    letterReviewerAcceptsEditor = await readTextFile(
      "/letters/reviewer-accepts-editor.txt"
    );
    letterReviewerRejects = await readTextFile("/letters/reviewer-rejects.txt");
    letterReviewerRejectsEditor = await readTextFile(
      "/letters/reviewer-rejects-editor.txt"
    );
    letterReviewerThanks = await readTextFile("/letters/reviewer-thanks.txt");
    letterReviewerThanksEditor = await readTextFile(
      "/letters/reviewer-thanks-editor.txt"
    );
    letterReviewerNoSecondRound = await readTextFile(
      "/letters/reviewer-no-second-round.txt"
    );
    letterAcceptedAuthors = await readTextFile(
      "/letters/article-accepted-authors.txt"
    );
    letterMinorAuthors = await readTextFile(
      "/letters/article-minor-authors.txt"
    );
    letterMajorAuthors = await readTextFile(
      "/letters/article-major-authors.txt"
    );
    letterRejectedAuthors = await readTextFile(
      "/letters/article-rejected-authors.txt"
    );
    letterAcceptedReviewers = await readTextFile(
      "/letters/article-accepted-reviewers.txt"
    );
    letterAcceptedChiefEditors = await readTextFile(
      "/letters/article-accepted-chief-editors.txt"
    );
    letterMinorReviewers = await readTextFile(
      "/letters/article-minor-reviewers.txt"
    );
    letterMajorReviewers = await readTextFile(
      "/letters/article-major-reviewers.txt"
    );
    letterRejectedReviewers = await readTextFile(
      "/letters/article-rejected-reviewers.txt"
    );
    letterRejectedChiefEditors = await readTextFile(
      "/letters/article-rejected-chief-editors.txt"
    );
  });

  let obtenerEditores = async () => {
    const editoresListados = await post(
      "ProcesoListarEditores",
      {
        token: getToken(),
      },
      "json"
    );
    editores = editoresListados.map((item) => {
      return {
        id: item.id,
        nombreUsuario: item.nombreUsuario,
        apellido1Usuario: item.apellido1Usuario,
        apellido2Usuario: item.apellido2Usuario,
        email: item.email,
        esEditorJefe: item.esEditorJefe,
      };
    });
    editores.sort((a, b) => {
      const nombreA =
        a.nombreUsuario + " " + a.apellido1Usuario + " " + a.apellido2Usuario;
      const nombreB =
        b.nombreUsuario + " " + b.apellido1Usuario + " " + b.apellido2Usuario;
      if (nombreA > nombreB) {
        return 1;
      }
      if (nombreA < nombreB) {
        return -1;
      }
      return 0;
    });
    editores = editores;
  };

  let obtenerRevisores = async () => {
    const revisoresListados = await post(
      "ProcesoListarPosiblesRevisores",
      {
        token: getToken(),
      },
      "json"
    );
    revisores = revisoresListados.map((item) => {
      return {
        id: item.id,
        nombreUsuario: item.nombreUsuario,
        apellido1Usuario: item.apellido1Usuario,
        apellido2Usuario: item.apellido2Usuario,
        institucionUsuario: item.institucionUsuario,
        email: item.email,
        fechaAceptado: "",
        aceptado: "",
        motivoRechazo: "",
        fechaProposicion: moment().format("YYYY-MM-DD HH:mm:ss"),
        decisionDocumento1: {
          decision: "",
          fechaRevision: "",
        },
        decisionDocumento2: {
          decision: "",
          fechaRevision: "",
        },
        sugerenciasRevisores: [],
      };
    });
    revisores.sort((a, b) => {
      const nombreA =
        a.nombreUsuario + " " + a.apellido1Usuario + " " + a.apellido2Usuario;
      const nombreB =
        b.nombreUsuario + " " + b.apellido1Usuario + " " + b.apellido2Usuario;
      if (nombreA > nombreB) {
        return 1;
      }
      if (nombreA < nombreB) {
        return -1;
      }
      return 0;
    });
    revisores = revisores;
  };

  let obtenerArticulo = async () => {
    articulo = await post(
      "Articulo",
      {
        token: getToken(),
        id_articulo: id,
      },
      "json"
    );

    if (
      articulo.estado === "Revision 2" &&
      !articulo.documento2[0] &&
      articulo.miRol === "AutorGestor"
    ) {
      // Está a la espera de subir nueva versión para revisión
      location.href = "/enviar-articulo/" + id;
    }

    switch (articulo.estado) {
      case "Enviado":
        estadoArticulo = dict["enviado"];
        estadoColor = "var(--revista-blue)";
        break;
      case "Revision":
        estadoArticulo = dict["1revision"];
        estadoColor = "var(--revista-blue)";
        break;
      case "Revision 2":
        estadoArticulo = dict["2revision"];
        estadoColor = "var(--revista-blue)";
        break;
      case "Aceptado":
        estadoArticulo = dict["aceptado"];
        estadoColor = "var(--revista-green)";
        break;
      case "Rechazado":
        estadoArticulo = dict["rechazado"];
        estadoColor = "var(--revista-red)";
        break;
    }
    version = articulo.documento2[0] ? 2 : 1;

    const authors =
      version === 1
        ? articulo.documento1[0].autores
        : articulo.documento2[0].autores;
    emailsAuthors = authors.map((item) => {
      return item.email;
    });

    // Editor

    if (articulo.miRol === "Editor" || articulo.miRol === "EditorJefe") {
      editoresSel = articulo.editores.map((item) => {
        return {
          id: item.id,
          nombreUsuario: item.nombreUsuario,
          apellido1Usuario: item.apellido1Usuario,
          apellido2Usuario: item.apellido2Usuario,
          aceptado: item.aceptado,
          fechaAceptado: item.fechaAceptado,
        };
      });
      revisoresSel = articulo.revisores.map((item) => {
        return {
          id: item.id,
          nombreUsuario: item.nombreUsuario,
          apellido1Usuario: item.apellido1Usuario,
          apellido2Usuario: item.apellido2Usuario,
          institucionUsuario: item.institucionUsuario,
          email: item.email,
          fechaAceptado: item.fechaAceptado,
          aceptado: item.aceptado,
          motivoRechazo: item.motivoRechazo,
          fechaProposicion: item.fechaProposicion,
          decisionDocumento1: item.decisionDocumento1,
          decisionDocumento2: item.decisionDocumento2,
          sugerenciasRevisores: item.sugerenciasRevisores,
        };
      });

      if (articulo.miRol === "Editor") {
        aceptacionEditor = editoresSel[0].aceptado;
        if (aceptacionEditor === "No") {
          articulo.miRol = "Autor";
        }
      }
    }

    // Revisor

    if (articulo.miRol === "Revisor") {
      posRevisor = articulo.revisores.findIndex((item) => {
        return item.soyYo;
      });
      if (posRevisor !== -1) {
        let pendienteRevision =
          version === 2 &&
          articulo.revisores[posRevisor].decisionDocumento2.decision === "";
        if (!pendienteRevision) {
          pendienteRevision =
            version === 1 &&
            articulo.revisores[posRevisor].decisionDocumento1.decision === "";
        }
        if (!pendienteRevision) {
          estadoRevisionDoc1 =
            articulo.revisores[posRevisor].decisionDocumento1.decision;
          if (version === 1) {
            estadoRevision =
              articulo.revisores[posRevisor].decisionDocumento1.decision;
          } else {
            estadoRevisionDoc2 =
              articulo.revisores[posRevisor].decisionDocumento2.decision;
            estadoRevision = estadoRevisionDoc2;
          }
        }
      }
    }

    //console.log(articulo);
  };

  let obtenerArticuloDocumentos = async () => {
    // Editor

    if (articulo.miRol === "Editor" || articulo.miRol === "EditorJefe") {
      let docA = "";
      let docE = "";
      for (let i = 0; i < articulo.revisores.length; i++) {
        if (articulo.revisores[i].decisionDocumento1.decision !== "") {
          docA = await post(
            "ObtenerDocumentoRevisionAutores",
            {
              token: getToken(),
              id_usuario: articulo.revisores[i].id,
              id_documento: articulo.documento1[0].id,
            },
            "text"
          );
          docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
          docA = atob(docA);
          docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
          docE = await post(
            "ObtenerDocumentoRevisionEditores",
            {
              token: getToken(),
              id_usuario: articulo.revisores[i].id,
              id_documento: articulo.documento1[0].id,
            },
            "text"
          );
          docE = docE.replace(/\\/g, "").replace(/"/g, "").trim();
          docE = atob(docE);
          docE = docE.replace(/\\/g, "").replace(/"/g, "").trim();
        }
        lettersAuthorsDoc1.push(docA);
        lettersEditorsDoc1.push(docE);
        docA = "";
        docE = "";
        if (articulo.revisores[i].decisionDocumento2.decision !== "") {
          docA = await post(
            "ObtenerDocumentoRevisionAutores",
            {
              token: getToken(),
              id_usuario: articulo.revisores[i].id,
              id_documento: articulo.documento2[0].id,
            },
            "text"
          );
          docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
          docA = atob(docA);
          docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
          docE = await post(
            "ObtenerDocumentoRevisionEditores",
            {
              token: getToken(),
              id_usuario: articulo.revisores[i].id,
              id_documento: articulo.documento2[0].id,
            },
            "text"
          );
          docE = docE.replace(/\\/g, "").replace(/"/g, "").trim();
          docE = atob(docE);
          docE = docE.replace(/\\/g, "").replace(/"/g, "").trim();
        }
        lettersAuthorsDoc2.push(docA);
        lettersEditorsDoc2.push(docE);
      }

      lettersAuthorsDoc1 = lettersAuthorsDoc1;
      lettersEditorsDoc1 = lettersEditorsDoc1;
      lettersAuthorsDoc2 = lettersAuthorsDoc2;
      lettersEditorsDoc2 = lettersEditorsDoc2;
    }

    // Revisor

    if (articulo.miRol === "Revisor") {
      let docA = "";
      let docE = "";

      const revisor = articulo.revisores.find((item) => {
        return item.soyYo;
      });

      if (revisor.decisionDocumento1.decision !== "") {
        docA = await post(
          "ObtenerDocumentoRevisionAutores",
          {
            token: getToken(),
            id_usuario: revisor.id,
            id_documento: articulo.documento1[0].id,
          },
          "text"
        );
        docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
        docA = atob(docA);
        docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
        docE = await post(
          "ObtenerDocumentoRevisionEditores",
          {
            token: getToken(),
            id_usuario: revisor.id,
            id_documento: articulo.documento1[0].id,
          },
          "text"
        );
        docE = docE.replace(/\\/g, "").replace(/"/g, "").trim();
        docE = atob(docE);
        docE = docE.replace(/\\/g, "").replace(/"/g, "").trim();
      }
      lettersAuthorsDoc1.push(docA);
      lettersEditorsDoc1.push(docE);
      docA = "";
      docE = "";
      if (revisor.decisionDocumento2.decision !== "") {
        docA = await post(
          "ObtenerDocumentoRevisionAutores",
          {
            token: getToken(),
            id_usuario: revisor.id,
            id_documento: articulo.documento2[0].id,
          },
          "text"
        );
        docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
        docA = atob(docA);
        docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
        docE = await post(
          "ObtenerDocumentoRevisionEditores",
          {
            token: getToken(),
            id_usuario: revisor.id,
            id_documento: articulo.documento2[0].id,
          },
          "text"
        );
        docE = docE.replace(/\\/g, "").replace(/"/g, "").trim();
        docE = atob(docE);
        docE = docE.replace(/\\/g, "").replace(/"/g, "").trim();
      }
      lettersAuthorsDoc2.push(docA);
      lettersEditorsDoc2.push(docE);

      lettersAuthorsDoc1 = lettersAuthorsDoc1;
      lettersEditorsDoc1 = lettersEditorsDoc1;
      lettersAuthorsDoc2 = lettersAuthorsDoc2;
      lettersEditorsDoc2 = lettersEditorsDoc2;
    }

    // Autor

    if (articulo.miRol === "Autor" || articulo.miRol === "AutorGestor") {
      let docA = "";
      for (let i = 0; i < articulo.revisores.length; i++) {
        docA = "";
        if (articulo.revisores[i].decisionDocumento1.decision !== "") {
          docA = await post(
            "ObtenerDocumentoRevisionAutores",
            {
              token: getToken(),
              id_usuario: articulo.revisores[i].id,
              id_documento: articulo.documento1[0].id,
            },
            "text"
          );
          docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
          docA = atob(docA);
          docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
        }
        lettersAuthorsDoc1.push(docA);
        docA = "";
        if (articulo.revisores[i].decisionDocumento2.decision !== "") {
          docA = await post(
            "ObtenerDocumentoRevisionAutores",
            {
              token: getToken(),
              id_usuario: articulo.revisores[i].id,
              id_documento: articulo.documento2[0].id,
            },
            "text"
          );
          docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
          docA = atob(docA);
          docA = docA.replace(/\\/g, "").replace(/"/g, "").trim();
        }
        lettersAuthorsDoc2.push(docA);

        lettersAuthorsDoc1 = lettersAuthorsDoc1;
        lettersAuthorsDoc2 = lettersAuthorsDoc2;
      }
    }

    // Resto de información

    if (
      articulo.miRol !== "Revisor" ||
      (articulo.miRol === "Revisor" &&
        (articulo.revisores[posRevisor].aceptado === "Si" ||
          articulo.revisores[posRevisor].decisionDocumento1.decision !== ""))
    ) {
      // Manuscrito

      if (version === 2) {
        documento2Doc = await post(
          "ObtenerDocumentoArticuloDoc",
          {
            token: getToken(),
            id_documento: articulo.documento2[0].id,
          },
          "text"
        );
        documento2Doc = documento2Doc
          .replace(/\\/g, "")
          .replace(/"/g, "")
          .trim();
        documento2Doc = atob(documento2Doc);
        documento2Doc = documento2Doc
          .replace(/\\/g, "")
          .replace(/"/g, "")
          .trim();
        documento2Pdf = await post(
          "ObtenerDocumentoArticuloPdf",
          {
            token: getToken(),
            id_documento: articulo.documento2[0].id,
          },
          "text"
        );
        documento2Pdf = documento2Pdf
          .replace(/\\/g, "")
          .replace(/"/g, "")
          .trim();
        documento2Pdf = atob(documento2Pdf);
        documento2Pdf = documento2Pdf
          .replace(/\\/g, "")
          .replace(/"/g, "")
          .trim();
      }
      documento1Doc = await post(
        "ObtenerDocumentoArticuloDoc",
        {
          token: getToken(),
          id_documento: articulo.documento1[0].id,
        },
        "text"
      );
      documento1Doc = documento1Doc.replace(/\\/g, "").replace(/"/g, "").trim();
      documento1Doc = atob(documento1Doc);
      documento1Doc = documento1Doc.replace(/\\/g, "").replace(/"/g, "").trim();

      documento1Pdf = await post(
        "ObtenerDocumentoArticuloPdf",
        {
          token: getToken(),
          id_documento: articulo.documento1[0].id,
        },
        "text"
      );
      documento1Pdf = documento1Pdf.replace(/\\/g, "").replace(/"/g, "").trim();
      documento1Pdf = atob(documento1Pdf);
      documento1Pdf = documento1Pdf.replace(/\\/g, "").replace(/"/g, "").trim();

      // Figuras

      if (version === 2) {
        for (let i = 0; i < articulo.documento2[0].figuras.length; i++) {
          figurasDoc2.push(null);
        }
        for (let i = 0; i < articulo.documento2[0].figuras.length; i++) {
          let image = await post(
            "ObtenerFiguraArticulo",
            {
              token: getToken(),
              id_figura: articulo.documento2[0].figuras[i].id,
            },
            "text"
          );
          image = image.replace(/\\/g, "").replace(/"/g, "").trim();
          image = atob(image);
          figurasDoc2[i] = image.replace(/\\/g, "").replace(/"/g, "").trim();
          figurasDoc2 = figurasDoc2;
        }
      }

      for (let i = 0; i < articulo.documento1[0].figuras.length; i++) {
        figurasDoc1.push(null);
      }
      for (let i = 0; i < articulo.documento1[0].figuras.length; i++) {
        let image = await post(
          "ObtenerFiguraArticulo",
          {
            token: getToken(),
            id_figura: articulo.documento1[0].figuras[i].id,
          },
          "text"
        );
        image = image.replace(/\\/g, "").replace(/"/g, "").trim();
        image = atob(image);
        figurasDoc1[i] = image.replace(/\\/g, "").replace(/"/g, "").trim();
        figurasDoc1 = figurasDoc1;
      }
    }
  };

  let seleccionarEditor = async () => {
    if (editores.length > 0 && editorSel !== "-1") {
      const pos = editoresSel.findIndex((item) => {
        return item.id === editorSel;
      });
      if (pos === -1) {
        const editor = editores.find((item) => {
          return item.id === editorSel;
        });
        editoresSel.push(editor);
        editoresSel = editoresSel;
        await post(
          "ProcesoAsignarEditor",
          {
            token: getToken(),
            id_articulo: id,
            id_usuario: editorSel,
          },
          null
        );

        let body = letterProposeEditor;
        body = body.replace(
          /%USUARIO%/g,
          editor.nombreUsuario +
            " " +
            editor.apellido1Usuario +
            " " +
            editor.apellido2Usuario
        );
        body = body.replace(
          /%TITULO%/g,
          version === 1
            ? articulo.documento1[0].titulo
            : articulo.documento2[0].titulo
        );
        await sendEmail(editor.email, "Propuesta como editor", body);
      }
    }
  };

  let eliminarEditor = (idEditor) => {
    const pos = editoresSel.findIndex((item) => {
      return item.id === idEditor;
    });
    editoresSel.splice(pos, 1);
    editoresSel = editoresSel;
    post(
      "ProcesoEliminarEditor",
      {
        token: getToken(),
        id_articulo: id,
        id_editor: idEditor,
      },
      null
    );
  };

  let seleccionarRevisor = () => {
    if (revisores.length > 0 && revisorSel !== "-1") {
      const pos = revisoresSel.findIndex((item) => {
        return item.id === revisorSel;
      });
      if (pos === -1) {
        const revisor = revisores.find((item) => {
          return item.id === revisorSel;
        });
        sendEmailEmail = [revisor.email];
        sendEmailSubject = "Propuesta como revisor";
        sendEmailBody = letterProposeReviewer.replace(
          /%USUARIO%/,
          revisor.nombreUsuario +
            " " +
            revisor.apellido1Usuario +
            " " +
            revisor.apellido2Usuario
        );
        sendEmailBody = sendEmailBody.replace(
          /%TITULO%/,
          version === 1
            ? articulo.documento1[0].titulo
            : articulo.documento2[0].titulo
        );
        sendEmailOnSent = seleccionarRevisorOk;
        sendEmailBeforeSend = null;
        sendEmailAdjuntos = [];

        window.$("#sendEmail").modal("show");
      }
    }
  };

  let seleccionarRevisorOk = async () => {
    const revisor = revisores.find((item) => {
      return item.id === revisorSel;
    });
    revisoresSel.push(revisor);
    revisoresSel = revisoresSel;
    post(
      "ProcesoAsignarRevisor",
      {
        token: getToken(),
        id_articulo: id,
        id_usuario: revisorSel,
      },
      null
    );

    articulo.revisores.push({
      id: revisor.id,
      nombreUsuario: revisor.nombreUsuario,
      apellido1Usuario: revisor.apellido1Usuario,
      apellido2Usuario: revisor.apellido2Usuario,
      institucionUsuario: revisor.institucionUsuario,
      email: revisor.email,
      fechaAceptado: moment().format("YYYY-MMMM-DD HH:mm:ss"),
      aceptado: "",
      motivoRechazo: "",
      fechaProposicion: "",
      decisionDocumento1: {
        decision: "",
        fechaRevision: "",
      },
      decisionDocumento2: {
        decision: "",
        fechaRevision: "",
      },
    });
    articulo = articulo;

    window.$("#sendEmail").modal("hide");
  };

  let eliminarRevisor = (idRevisor) => {
    const pos = revisoresSel.findIndex((item) => {
      return item.id === idRevisor;
    });
    revisoresSel.splice(pos, 1);
    revisoresSel = revisoresSel;
    post(
      "ProcesoEliminarRevisor",
      {
        token: getToken(),
        id_articulo: id,
        id_usuario: idRevisor,
      },
      null
    );

    articulo.revisores.splice(pos, 1);
    articulo = articulo;

    window.$("#removeReviewer").modal("hide");
  };

  let aceptarRevision = async () => {
    const revisor = articulo.revisores.find((item) => {
      return item.soyYo;
    });

    if (revisor) {
      let body = letterReviewerAccepts;
      body = body.replace(
        /%USUARIO%/g,
        revisor.nombreUsuario +
          " " +
          revisor.apellido1Usuario +
          " " +
          revisor.apellido2Usuario
      );
      body = body.replace(
        /%TITULO%/g,
        version === 1
          ? articulo.documento1[0].titulo
          : articulo.documento2[0].titulo
      );
      await sendEmail(revisor.email, "Solicitud de revisión aceptada", body);

      for (let i = 0; i < articulo.editores.length; i++) {
        const editor = articulo.editores[i];
        if (editor.aceptado === "Si") {
          body = letterReviewerAcceptsEditor;
          body = body.replace(
            /%USUARIO%/g,
            editor.nombreUsuario +
              " " +
              editor.apellido1Usuario +
              " " +
              editor.apellido2Usuario
          );
          body = body.replace(
            /%TITULO%/g,
            version === 1
              ? articulo.documento1[0].titulo
              : articulo.documento2[0].titulo
          );
          body = body.replace(
            /%REVISOR%/g,
            revisor.nombreUsuario +
              " " +
              revisor.apellido1Usuario +
              " " +
              revisor.apellido2Usuario
          );
          await sendEmail(editor.email, "Solicitud de revisión aceptada", body);
        }
      }
    }

    await post(
      "ProcesoAceptarRevision",
      {
        token: getToken(),
        id_articulo: id,
      },
      null
    );
    window.$("#aceptarRevision").modal("hide");
    location.href = ".";
  };

  let rechazarRevision = async () => {
    const revisor = articulo.revisores.find((item) => {
      return item.soyYo;
    });

    if (revisor) {
      let body = letterReviewerRejects;
      body = body.replace(
        /%USUARIO%/g,
        revisor.nombreUsuario +
          " " +
          revisor.apellido1Usuario +
          " " +
          revisor.apellido2Usuario
      );
      body = body.replace(
        /%TITULO%/g,
        version === 1
          ? articulo.documento1[0].titulo
          : articulo.documento2[0].titulo
      );
      await sendEmail(revisor.email, "Solicitud de revisión rechazada", body);

      for (let i = 0; i < articulo.editores.length; i++) {
        const editor = articulo.editores[i];
        if (editor.aceptado === "Si") {
          body = letterReviewerRejectsEditor;
          body = body.replace(
            /%USUARIO%/g,
            editor.nombreUsuario +
              " " +
              editor.apellido1Usuario +
              " " +
              editor.apellido2Usuario
          );
          body = body.replace(
            /%TITULO%/g,
            version === 1
              ? articulo.documento1[0].titulo
              : articulo.documento2[0].titulo
          );
          body = body.replace(
            /%REVISOR%/g,
            revisor.nombreUsuario +
              " " +
              revisor.apellido1Usuario +
              " " +
              revisor.apellido2Usuario
          );
          await sendEmail(
            editor.email,
            "Solicitud de revisión rechazada",
            body
          );
        }
      }
    }

    const listaRevisoresSugeridos = revisionPropuestaRevisores.map(
      (propuesta) => {
        return {
          nombreApellidos: propuesta.nombreCompleto,
          institucion: propuesta.institucion,
          email: propuesta.email,
        };
      }
    );
    await post(
      "ProcesoRechazarRevision",
      {
        token: getToken(),
        id_articulo: id,
        motivoRechazo: dict[revisionMotivoRechazo],
        listaRevisoresSugeridos,
      },
      null
    );
    window.$("#rechazarRevision").modal("hide");
    location.href = "/articulos-revisor";
  };

  let enviarRevision = async (decision) => {
    if (letterAuthors === "") {
      errorMsgRevisor = dict["errorSinCartaAutores"];
    } else if (letterEditors === "") {
      errorMsgRevisor = dict["errorSinCartaEditores"];
    } else {
      loading = true;
      loadingText = dict["enviandoRevision"] + "...";

      if (!aceptarSegundaRevision) {
        const revisor = articulo.revisores.find((item) => {
          return item.soyYo;
        });

        if (revisor) {
          let body = letterReviewerNoSecondRound;
          body = body.replace(
            /%USUARIO%/g,
            revisor.nombreUsuario +
              " " +
              revisor.apellido1Usuario +
              " " +
              revisor.apellido2Usuario
          );
          body = body.replace(
            /%TITULO%/g,
            version === 1
              ? articulo.documento1[0].titulo
              : articulo.documento2[0].titulo
          );
          await sendEmail(
            revisor.email,
            "Indisponibilidad para nueva ronda de revisiones",
            body
          );
        }

        await post(
          "ProcesoRechazarRevision",
          {
            token: getToken(),
            id_articulo: id,
            motivoRechazo:
              "Sin disponibilidad para una segunda ronda de revisiones.",
            listaRevisoresSugeridos: [],
          },
          null
        );
      }

      await post(
        "ProcesoEnviarRevision",
        {
          token: getToken(),
          id_documento:
            version === 1
              ? articulo.documento1[0].id
              : articulo.documento2[0].id,
          decision,
          aceptada2Revision: aceptarSegundaRevision ? "1" : "0",
        },
        null
      );

      loadingText = dict["enviandoCartaAutores"] + "...";
      await post(
        "SubirDocumentoRevisionAutores",
        {
          token: getToken(),
          id_documento:
            version === 1
              ? articulo.documento1[0].id
              : articulo.documento2[0].id,
          documento: btoa(letterAuthors),
        },
        null
      );

      if (letterEditors !== "") {
        loadingText = dict["enviandoCartaEditores"] + "...";
        await post(
          "SubirDocumentoRevisionEditores",
          {
            token: getToken(),
            id_documento:
              version === 1
                ? articulo.documento1[0].id
                : articulo.documento2[0].id,
            documento: btoa(letterEditors),
          },
          null
        );
      }

      const revisor = articulo.revisores.find((item) => {
        return item.soyYo;
      });

      if (revisor) {
        let body = letterReviewerThanks;
        body = body.replace(
          /%USUARIO%/g,
          revisor.nombreUsuario +
            " " +
            revisor.apellido1Usuario +
            " " +
            revisor.apellido2Usuario
        );
        body = body.replace(
          /%TITULO%/g,
          version === 1
            ? articulo.documento1[0].titulo
            : articulo.documento2[0].titulo
        );
        await sendEmail(revisor.email, "Envío de revisión", body);

        for (let i = 0; i < articulo.editores.length; i++) {
          const editor = articulo.editores[i];
          if (editor.aceptado === "Si") {
            body = letterReviewerThanksEditor;
            body = body.replace(
              /%USUARIO%/g,
              editor.nombreUsuario +
                " " +
                editor.apellido1Usuario +
                " " +
                editor.apellido2Usuario
            );
            body = body.replace(
              /%TITULO%/g,
              version === 1
                ? articulo.documento1[0].titulo
                : articulo.documento2[0].titulo
            );
            body = body.replace(
              /%REVISOR%/g,
              revisor.nombreUsuario +
                " " +
                revisor.apellido1Usuario +
                " " +
                revisor.apellido2Usuario
            );
            await sendEmail(editor.email, "Envío de revisión", body);
          }
        }
      }

      errorMsgRevisor = "";
      loadingText = dict["finalizando"] + "...";
      location.href = ".";
    }

    window.$("#revisionAceptarArticulo").modal("hide");
    window.$("#revisionAceptarArticuloCambiosMenores").modal("hide");
    window.$("#revisionAceptarArticuloCambiosMayores").modal("hide");
    window.$("#revisionRechazarArticulo").modal("hide");
  };

  let addLetterAuthors = () => {
    loadFile("letterAuthorsInput", addLetterAuthorsReady);
  };

  let addLetterAuthorsReady = (content) => {
    letterAuthors = content;
  };

  let addLetterEditors = () => {
    loadFile("letterEditorsInput", addLetterEditorsReady);
  };

  let addLetterEditorsReady = (content) => {
    letterEditors = content;
  };

  let tomarDecision = async (decision) => {
    await post(
      "ProcesoTomarDecision",
      {
        token: getToken(),
        id_articulo: id,
        decision,
      },
      null
    );

    location.href = ".";
  };

  let aceptarEditor = async (decision) => {
    await post(
      "ProcesoDecisionEditorial",
      {
        token: getToken(),
        id_articulo: articulo.id,
        decision,
      },
      null
    );
    aceptacionEditor = decision;
    if (aceptacionEditor === "No") {
      articulo.miRol = "Autor";
      articulo = articulo;
    }
  };
</script>

<style>
  table.articulo {
    width: 100%;
    margin-bottom: 20px;
    color: var(--revista-black);
  }

  table.articulo td {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  td.comboButton {
    display: flex;
  }

  td.comboButton div {
    margin-top: 0px;
    margin-left: 20px;
  }

  table.revisores tr:first-child td {
    padding-top: 10px;
    border-top-color: lightgray;
    border-top-width: 1px;
    border-top-style: solid;
  }

  h4.estado {
    border-top-color: lightgray;
    border-top-style: solid;
    border-top-width: 1px;
    border-bottom-color: lightgray;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  h4.estado span {
    color: var(--revista-blue);
  }

  table.propuestaRevisor {
    border-color: lightgray;
    border-style: solid;
    border-width: 1px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    color: var(--revista-black);
  }

  table.propuestaRevisor td {
    padding: 10px;
  }

  td.propuestaRevisionButtons {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  div.info {
    margin-top: 10px;
  }

  div.info img {
    width: 50px;
  }

  div.info span {
    display: block;
    margin-bottom: 10px;
  }

  div.info a {
    display: flex;
    align-items: center;
  }

  div.info a img {
    margin-right: 10px;
  }

  div.documento {
    margin-top: 10px;
  }

  div.tableEnd {
    width: 100%;
    height: 1px;
    background-color: lightgray;
  }

  div.botonesDecision {
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
</style>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">
  <!-- Menu -->

  <Menu {pageName} />

  <!-- Breadcrumbs -->

  <Breadcrumbs pageName={dict[pageName]} />

  <!-- Body -->

  <section class="section">
    <div class="container">
      <h3 class="titulo">{dict['articulo']}</h3>
      {#if articulo}
        <!-- Estado -->
        <h4 class="subtitulo estado">
          {dict['estado']}:
          <span style="color: {estadoColor}">{estadoArticulo}</span>
        </h4>

        {#if articulo.miRol === 'Revisor' && estadoRevision === ''}
          <!-- Propuesta revisor -->

          {#if articulo.revisores[posRevisor].aceptado === 'Si'}
            <!-- Subida de revisión -->
            <table class="propuestaRevisor">
              <tr>
                <td>{dict['revisionAceptada']}</td>
              </tr>
              {#if errorMsgRevisor !== ''}
                <tr>
                  <td>
                    <div class="alert alert-danger" role="alert">
                      {errorMsgRevisor}
                    </div>
                  </td>
                </tr>
              {/if}
              <tr>
                <td>
                  <b>{dict['cartaAutores']}:</b>
                  <div class="info">
                    <span>{dict['infoCartaAutores']}</span>
                    <span>
                      <b>{dict['importante']}</b>
                      {dict['infoCartaPlantilla']}
                    </span>
                    <a
                      href={lang === 'es' ? '/templates/letter_authors_es.docx' : '/templates/letter_authors_en.docx'}>
                      <img src="/images/revista/docx.svg" alt="DOCX Template" />
                      <span>{dict['descarga']}</span>
                    </a>
                  </div>
                  <div class="form-group documento">
                    <input
                      id="letterAuthorsInput"
                      type="file"
                      class="form-control-file"
                      accept=".doc,.docx"
                      on:change={() => addLetterAuthors()} />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <b>{dict['cartaEditores']}:</b>
                  <div class="info">
                    <span>{dict['infoCartaEditores']}</span>
                    <span>
                      <b>{dict['importante']}</b>
                      {dict['infoCartaPlantilla']}
                    </span>
                    <a
                      href={lang === 'es' ? '/templates/letter_editors_es.docx' : '/templates/letter_editors_en.docx'}>
                      <img src="/images/revista/docx.svg" alt="DOCX Template" />
                      <span>{dict['descarga']}</span>
                    </a>
                  </div>
                  <div class="form-group documento">
                    <input
                      id="letterEditorsInput"
                      type="file"
                      class="form-control-file"
                      accept=".doc,.docx"
                      on:change={() => addLetterEditors()} />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="propuestaRevisionButtons">
                  <IconButton
                    text={dict['aceptarParaPublicacion']}
                    icon="/images/revista/revisor-v.svg"
                    color="var(--revista-green)"
                    onClick={() => {
                      window.$('#revisionAceptarArticulo').modal('show');
                    }} />
                  {#if version === 1}
                    <IconButton
                      text={dict['aceptarConCambiosMenores']}
                      icon="/images/revista/revisor-v-minor.svg"
                      color="var(--revista-orange)"
                      onClick={() => {
                        window
                          .$('#revisionAceptarArticuloCambiosMenores')
                          .modal('show');
                      }} />
                    <IconButton
                      text={dict['aceptarConCambiosMayores']}
                      icon="/images/revista/revisor-v-major.svg"
                      color="var(--revista-orange-red)"
                      onClick={() => {
                        window
                          .$('#revisionAceptarArticuloCambiosMayores')
                          .modal('show');
                      }} />
                  {/if}
                  <IconButton
                    text={dict['rechazar']}
                    icon="/images/revista/revisor-x.svg"
                    color="var(--revista-red)"
                    onClick={() => {
                      window.$('#revisionRechazarArticulo').modal('show');
                    }} />
                </td>
              </tr>
            </table>
          {:else if articulo.revisores[posRevisor].aceptado === ''}
            <!-- Como revisor hay que tomar una decisión respecto a la propuesta-->
            <table class="propuestaRevisor">
              <tr>
                <td>{dict['propuestaRevision']}</td>
              </tr>
              <tr>
                <td class="propuestaRevisionButtons">
                  <IconButton
                    text={dict['aceptar']}
                    icon="/images/revista/revisor-v.svg"
                    color="var(--revista-green)"
                    onClick={() => {
                      window.$('#aceptarRevision').modal('show');
                    }} />
                  <IconButton
                    text={dict['rechazar']}
                    icon="/images/revista/revisor-x.svg"
                    color="var(--revista-red)"
                    onClick={() => {
                      window.$('#rechazarRevision').modal('show');
                    }} />
                </td>
              </tr>
            </table>
          {/if}
        {/if}

        <!-- Editores -->
        {#if articulo.miRol === 'Editor'}
          {#if aceptacionEditor === ''}
            <!-- Como editor hay que tomar una decisión respecto a la propuesta-->
            <table class="propuestaRevisor">
              <tr>
                <td>{dict['propuestaEditor']}</td>
              </tr>
              <tr>
                <td class="propuestaRevisionButtons">
                  <IconButton
                    text={dict['aceptar']}
                    icon="/images/revista/revisor-v.svg"
                    color="var(--revista-green)"
                    onClick={() => aceptarEditor('Si')} />
                  <IconButton
                    text={dict['rechazar']}
                    icon="/images/revista/revisor-x.svg"
                    color="var(--revista-red)"
                    onClick={() => aceptarEditor('No')} />
                </td>
              </tr>
            </table>
          {/if}
        {/if}

        {#if articulo.miRol === 'EditorJefe'}
          <h4 class="subtitulo">{dict['editor']}</h4>
          <table class="articulo">
            <tr>
              <td class="comboButton">
                <select bind:value={editorSel}>
                  <option value="-1" />
                  {#each editores as editor}
                    <option value={editor.id}>
                      {editor.nombreUsuario}
                      {editor.apellido1Usuario}
                      {editor.apellido2Usuario}
                    </option>
                  {/each}
                </select>
                {#if editoresSel.length === 0}
                  <div
                    class="button button-sm button-primary botonBuscar"
                    on:click={() => seleccionarEditor()}>
                    {dict['anadirEditor']}
                  </div>
                {/if}
              </td>
            </tr>
          </table>
          {#each editoresSel as editor, i}
            <ArticleEditorItem
              {editor}
              onRemove={() => eliminarEditor(editor.id)}
              last={i === editoresSel.length - 1} />
          {/each}
        {/if}

        <!-- Revisores -->
        {#if articulo.miRol === 'EditorJefe' || (articulo.miRol === 'Editor' && aceptacionEditor === 'Si')}
          <h4 class="subtitulo">
            {dict['revisores']}
            ({articulo.revisores.length})
          </h4>

          <table class="articulo">
            <tr>
              <td class="comboButton">
                <select bind:value={revisorSel}>
                  <option value="-1" />
                  {#each revisores as revisor}
                    <option value={revisor.id}>
                      {revisor.nombreUsuario}
                      {revisor.apellido1Usuario}
                      {revisor.apellido2Usuario}
                    </option>
                  {/each}
                </select>
                <div
                  class="button button-sm button-primary botonBuscar"
                  on:click={() => seleccionarRevisor()}>
                  {dict['anadirRevisor']}
                </div>
              </td>
            </tr>
          </table>

          {#each revisoresSel as revisor, i}
            <ArticleReviewerItem
              reviewer={revisor}
              articleVersion={version}
              onRemove={() => {
                removeReviewerAction = () => eliminarRevisor(revisor.id);
                window.$('#removeReviewer').modal('show');
              }}
              last={i === revisoresSel.length - 1} />
          {/each}
        {/if}

        {#if version === 2}
          <!-- Versión 2 -->

          <ArticleVersion
            idArticulo={articulo.id}
            fechaSolicitud={articulo.fechaSolicitud}
            documento={articulo.documento2[0]}
            version={2}
            showInfo={articulo.miRol !== 'Revisor' || (articulo.miRol === 'Revisor' && articulo.revisores[posRevisor].aceptado === 'Si')}
            figurasDoc={figurasDoc2}
            documentoFileDoc={documento2Doc}
            documentoFilePdf={documento2Pdf}
            miRol={articulo.miRol}
            revisores={articulo.revisores}
            lettersAuthorsDoc={lettersAuthorsDoc2}
            lettersEditorsDoc={lettersEditorsDoc2}
            showReviewers={(articulo.miRol !== 'Autor' && articulo.miRol !== 'AutorGestor') || ((articulo.miRol === 'Autor' || articulo.miRol === 'AutorGestor') && (articulo.estado === 'Aceptado' || articulo.aceptado === 'Rechazado'))}
            collapsed={false} />

          <div class="tableEnd" />
        {/if}

        <!-- Versión 1 -->

        <ArticleVersion
          idArticulo={articulo.id}
          fechaSolicitud={articulo.fechaSolicitud}
          documento={articulo.documento1[0]}
          version={1}
          showInfo={articulo.miRol !== 'Revisor' || (articulo.miRol === 'Revisor' && (articulo.revisores[posRevisor].aceptado === 'Si' || articulo.revisores[posRevisor].decisionDocumento1.decision !== ''))}
          figurasDoc={figurasDoc1}
          documentoFileDoc={documento1Doc}
          documentoFilePdf={documento1Pdf}
          miRol={articulo.miRol}
          revisores={articulo.revisores}
          lettersAuthorsDoc={lettersAuthorsDoc1}
          lettersEditorsDoc={lettersEditorsDoc1}
          showReviewers={(articulo.miRol !== 'Autor' && articulo.miRol !== 'AutorGestor') || version === 2}
          collapsed={version === 2} />

        <div class="tableEnd" />

        {#if articulo.miRol === 'EditorJefe' || (articulo.miRol === 'Editor' && aceptacionEditor === 'Si')}
          <div class="botonesDecision">
            {#if articulo.estado !== 'Aceptado' && articulo.estado !== 'Rechazado'}
              <IconButton
                text={dict['aceptarParaPublicacion']}
                icon="/images/revista/revisor-v.svg"
                color="var(--revista-green)"
                onClick={() => {
                  sendEmailEmail = emailsAuthors;
                  sendEmailSubject = 'Artículo aceptado en revista';
                  sendEmailBody = letterAcceptedAuthors;
                  sendEmailBody = sendEmailBody.replace(/%TITULO%/, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                  sendEmailAdjuntos = [];
                  sendEmailOnSent = async () => {
                    for (let i = 0; i < articulo.revisores.length; i++) {
                      const revisor = articulo.revisores[i];
                      if (revisor.aceptado === 'Si') {
                        let body = letterAcceptedReviewers;
                        body = body.replace(/%TITULO%/g, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                        await sendEmail(revisor.email, 'Decisión sobre publicación de artículo', body);
                      }
                    }
                    for (let i = 0; i < editores.length; i++) {
                      const editor = editores[i];
                      if (editor.esEditorJefe) {
                        let body = letterAcceptedChiefEditors;
                        body = body.replace(/%TITULO%/g, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                        await sendEmail(editor.email, 'Decisión sobre publicación de artículo', body);
                      }
                    }
                    tomarDecision('Aceptado');
                  };
                  sendEmailBeforeSend = () => {
                    loading = true;
                    loadingText = dict['actualizandoEstadoArticulo'] + '...';
                  };
                  window.$('#sendEmail').modal('show');
                }} />
            {/if}
            {#if articulo.estado !== 'Aceptado' && articulo.estado !== 'Rechazado' && articulo.estado !== 'Revision 2'}
              <IconButton
                text={dict['aceptarConCambiosMenores']}
                icon="/images/revista/revisor-v-minor.svg"
                color="var(--revista-orange)"
                onClick={() => {
                  sendEmailEmail = emailsAuthors;
                  sendEmailSubject = 'Artículo aceptado en revista con cambios menores';
                  sendEmailBody = letterMinorAuthors;
                  sendEmailBody = sendEmailBody.replace(/%TITULO%/, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                  let letters = version === 1 ? lettersAuthorsDoc1 : lettersAuthorsDoc2;
                  letters = letters.filter((l) => {
                    return l !== '';
                  });
                  sendEmailAdjuntos = letters.map((item, index) => {
                    return { nombre: 'Revisor ' + (index + 1) + '.doc', archivo: btoa(item) };
                  });
                  sendEmailOnSent = async () => {
                    for (let i = 0; i < articulo.revisores.length; i++) {
                      const revisor = articulo.revisores[i];
                      if (revisor.aceptado === 'Si') {
                        let body = letterMinorReviewers;
                        body = body.replace(/%TITULO%/g, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                        await sendEmail(revisor.email, 'Decisión sobre publicación de artículo', body);
                      }
                    }
                    tomarDecision('Revision 2');
                  };
                  sendEmailBeforeSend = () => {
                    loading = true;
                    loadingText = dict['actualizandoEstadoArticulo'] + '...';
                  };
                  window.$('#sendEmail').modal('show');
                }} />
            {/if}
            {#if articulo.estado !== 'Aceptado' && articulo.estado !== 'Rechazado' && articulo.estado !== 'Revision 2'}
              <IconButton
                text={dict['aceptarConCambiosMayores']}
                icon="/images/revista/revisor-v-major.svg"
                color="var(--revista-orange-red)"
                onClick={() => {
                  sendEmailEmail = emailsAuthors;
                  sendEmailSubject = 'Artículo aceptado en revista con cambios mayores';
                  sendEmailBody = letterMajorAuthors;
                  sendEmailBody = sendEmailBody.replace(/%TITULO%/, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                  let letters = version === 1 ? lettersAuthorsDoc1 : lettersAuthorsDoc2;
                  letters = letters.filter((l) => {
                    return l !== '';
                  });
                  sendEmailAdjuntos = letters.map((item, index) => {
                    return { nombre: 'Revisor ' + (index + 1) + '.doc', archivo: btoa(item) };
                  });
                  sendEmailOnSent = async () => {
                    for (let i = 0; i < articulo.revisores.length; i++) {
                      const revisor = articulo.revisores[i];
                      if (revisor.aceptado === 'Si') {
                        let body = letterMajorReviewers;
                        body = body.replace(/%TITULO%/g, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                        await sendEmail(revisor.email, 'Decisión sobre publicación de artículo', body);
                      }
                    }
                    tomarDecision('Revision 2');
                  };
                  sendEmailBeforeSend = () => {
                    loading = true;
                    loadingText = dict['actualizandoEstadoArticulo'] + '...';
                  };
                  window.$('#sendEmail').modal('show');
                }} />
            {/if}
            {#if articulo.estado !== 'Aceptado' && articulo.estado !== 'Rechazado'}
              <IconButton
                text={dict['rechazar']}
                icon="/images/revista/revisor-x.svg"
                color="var(--revista-red)"
                onClick={() => {
                  sendEmailEmail = emailsAuthors;
                  sendEmailSubject = 'Artículo rechazado en revista';
                  sendEmailBody = letterRejectedAuthors;
                  sendEmailBody = sendEmailBody.replace(/%TITULO%/, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                  let letters = version === 1 ? lettersAuthorsDoc1 : lettersAuthorsDoc2;
                  letters = letters.filter((l) => {
                    return l !== '';
                  });
                  sendEmailAdjuntos = letters.map((item, index) => {
                    return { nombre: 'Revisor ' + (index + 1) + '.doc', archivo: btoa(item) };
                  });
                  sendEmailOnSent = async () => {
                    for (let i = 0; i < articulo.revisores.length; i++) {
                      const revisor = articulo.revisores[i];
                      if (revisor.aceptado === 'Si') {
                        let body = letterRejectedReviewers;
                        body = body.replace(/%TITULO%/g, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                        await sendEmail(revisor.email, 'Decisión sobre publicación de artículo', body);
                      }
                    }
                    for (let i = 0; i < editores.length; i++) {
                      const editor = editores[i];
                      if (editor.esEditorJefe) {
                        let body = letterRejectedChiefEditors;
                        body = body.replace(/%TITULO%/g, version === 1 ? articulo.documento1[0].titulo : articulo.documento2[0].titulo);
                        await sendEmail(editor.email, 'Decisión sobre publicación de artículo', body);
                      }
                    }
                    tomarDecision('Rechazado');
                  };
                  sendEmailBeforeSend = () => {
                    loading = true;
                    loadingText = dict['actualizandoEstadoArticulo'] + '...';
                  };
                  window.$('#sendEmail').modal('show');
                }} />
            {/if}
          </div>
        {/if}
      {/if}
    </div>
  </section>
  <Footer />
</div>
<div class="snackbars" id="form-output-global" />
<AcceptCancelDialog
  id="removeReviewer"
  titulo={dict['eliminarRevisor']}
  tituloAceptar={dict['eliminar']}
  tituloCancelar={dict['cancelar']}
  aceptarAction={removeReviewerAction}
  text={dict['preguntaEliminarRevisor']} />
<AcceptCancelDialog
  id="aceptarRevision"
  titulo={dict['aceptarRevision']}
  tituloAceptar={dict['aceptar']}
  tituloCancelar={dict['cancelar']}
  aceptarAction={aceptarRevision}
  text={dict['preguntaAceptarRevision']} />
<EmailDialog
  id="sendEmail"
  email={sendEmailEmail}
  subject={sendEmailSubject}
  body={sendEmailBody}
  attached={sendEmailAdjuntos}
  beforeSend={sendEmailBeforeSend}
  onSent={sendEmailOnSent} />
<RechazarRevisionDialog
  id="rechazarRevision"
  bind:motivo={revisionMotivoRechazo}
  bind:propuestaRevisores={revisionPropuestaRevisores}
  onReject={rechazarRevision} />
<AcceptCancelDialogRevision
  id="revisionAceptarArticulo"
  titulo={dict['aceptarParaPublicacion']}
  tituloAceptar={dict['aceptar']}
  tituloCancelar={dict['cancelar']}
  aceptarAction={() => enviarRevision('Aceptado')}
  text={dict['preguntaRevisionAceptarArticulo']}
  bind:aceptarSegundaRevision
  {version} />
<AcceptCancelDialogRevision
  id="revisionAceptarArticuloCambiosMenores"
  titulo={dict['aceptarConCambiosMenores']}
  tituloAceptar={dict['aceptar']}
  tituloCancelar={dict['cancelar']}
  aceptarAction={() => enviarRevision('CambiosMenores')}
  text={dict['preguntaRevisionAceptarArticuloCambiosMenores']}
  bind:aceptarSegundaRevision
  {version} />
<AcceptCancelDialogRevision
  id="revisionAceptarArticuloCambiosMayores"
  titulo={dict['aceptarConCambiosMayores']}
  tituloAceptar={dict['aceptar']}
  tituloCancelar={dict['cancelar']}
  aceptarAction={() => enviarRevision('CambiosMayores')}
  text={dict['preguntaRevisionAceptarArticuloCambiosMayores']}
  bind:aceptarSegundaRevision
  {version} />
<AcceptCancelDialogRevision
  id="revisionRechazarArticulo"
  titulo={dict['rechazar']}
  tituloAceptar={dict['aceptar']}
  tituloCancelar={dict['cancelar']}
  aceptarAction={() => enviarRevision('Rechazado')}
  text={dict['preguntaRevisionRechazarArticulo']}
  bind:aceptarSegundaRevision
  {version} />
{#if loading}
  <LoadingDialog text={loadingText} />
{/if}
